import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { useLocation } from 'react-router';
import { useNavigateTo } from 'shared/hooks/router';
import { SmartConfigSending } from 'console/smart-config/components/sending';
import { useLegacySaver } from 'console/smart-config/legacy-saver';
export const SmartConfigRouterSending = memo(function SmartConfigRouterSending() {
    const { state } = useLocation();
    const onCancel = useNavigateTo('/smart-config/prepare', { state });
    const onSave = useLegacySaver();
    return (_jsx(SmartConfigSending, { name: state?.name, password: state?.password, onCancel: onCancel, onSaveConfig: onSave }));
});
